define.alias("shared/components/shared/post/secondary/wrapper", "calendar/components/shared/post/secondary/wrapper");